export const REQUIRED_SPREADSHEET_FILE_TYPES = [
	{ id: "PHONEPE", name: "Phone Pe" },
	{ id: "BANK_STATEMENT", name: "Bank Statement" },
	{ id: "AMEX", name: "Amex" },
	{ id: "CARD", name: "Card" },
	{ id: "UPI", name: "UPI" },
	{ id: "MAGICPIN", name: "Magicpin" },
	{ id: "ZOMATO", name: "Zomato" },
];

export const UPLOAD_CALENDAR_STATUS = {
	COMPLETE: "complete",
	PARTIAL: "partial",
	NONE: "none",
};

export const isSuccessfulUploadStatus = (status) => {
	const normalized = String(status || "").toUpperCase();
	if (!normalized) return false;
	if (normalized.includes("FAILED") || normalized.includes("ERROR")) return false;
	return true;
};

export const toLocalDateKey = (value) => {
	if (!value) return null;
	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return null;

	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const day = String(date.getDate()).padStart(2, "0");
	return `${year}-${month}-${day}`;
};

export const buildUploadsByDate = (logs = []) => {
	const uploadsByDate = {};

	logs.forEach((log) => {
		if (!isSuccessfulUploadStatus(log?.status)) return;

		const fileType = String(log?.file_type || "").trim().toUpperCase();
		if (!fileType || fileType === "PAY_BY_LINK") return;

		const dateKey = toLocalDateKey(log?.date || log?.created_at);
		if (!dateKey) return;

		if (!uploadsByDate[dateKey]) uploadsByDate[dateKey] = new Set();
		uploadsByDate[dateKey].add(fileType);
	});

	return uploadsByDate;
};

export const getUploadDayStatus = (dateKey, uploadsByDate, todayKey = toLocalDateKey(new Date())) => {
	if (!dateKey || dateKey > todayKey) return null;

	const uploadedTypes = uploadsByDate[dateKey] || new Set();
	const uploadedCount = REQUIRED_SPREADSHEET_FILE_TYPES.filter((type) => uploadedTypes.has(type.id)).length;

	if (uploadedCount === 0) return UPLOAD_CALENDAR_STATUS.NONE;
	if (uploadedCount === REQUIRED_SPREADSHEET_FILE_TYPES.length) return UPLOAD_CALENDAR_STATUS.COMPLETE;
	return UPLOAD_CALENDAR_STATUS.PARTIAL;
};

export const buildUploadsByDateFromApi = (apiResult = {}) => {
	const uploadsByDate = {};
	const raw = apiResult?.uploadsByDate || {};

	Object.entries(raw).forEach(([dateKey, types]) => {
		uploadsByDate[dateKey] = new Set(Array.isArray(types) ? types : []);
	});

	return uploadsByDate;
};
